export default __webpack_public_path__ + "static/media/flower_2.908c853a.png";